/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-16 22:11:48
 *
 *******************************************************/
/// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues } from 'redux-form';
import { FormLayout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderSelect } from 'src/components/views/common/forms/render-select';
import RenderAutocompleteV2 from 'src/components/views/common/autocomplete-hoc-v2';
import {
  FILTER_OPTION_DISPLAY_TYPES_PRODUCT_TYPE,
  FILTER_OPTION_SELECT_TYPES,
  getFilterOptionValueTypes
} from 'src/constants/filter-tree';
import { APP_LANGUAGE_ENGLISH_VALUE } from 'src/constants/language-setting';

type Props = WithI18nProps;

class ProductType extends Component<Props> {
  render() {
    const { i18n } = this.props;
    const displayTypes = FILTER_OPTION_DISPLAY_TYPES_PRODUCT_TYPE.map(function (type) {
      return {
        ...type,
        label: i18n.translate(type.label)
      };
    });
    const optionSelect = FILTER_OPTION_SELECT_TYPES.map(function (type) {
      return {
        ...type,
        label: i18n.translate(type.label)
      };
    });
    const { optionType, productTypeOptionValues, appLanguage } = this.props;
    const optionValues = getFilterOptionValueTypes(optionType, appLanguage, i18n);

    return (
      <FormLayout>
        <Field
          name="productTypeDisplayType"
          component={RenderSelect}
          label={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionDisplay_Label'
          )}
          options={displayTypes}
          tooltip={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionDisplay_Tooltip'
          )}
        />

        <Field
          name="productTypeOptionSelect"
          component={RenderSelect}
          label={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionSelect_Label'
          )}
          options={optionSelect}
          tooltip={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionSelect_Tooltip'
          )}
        />

        <Field
          name="productTypeOptionValues"
          component={RenderSelect}
          label={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionValues_Label'
          )}
          options={optionValues}
          tooltip={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionValues_Tooltip'
          )}
        />
        {productTypeOptionValues === 'specific' ? (
          <Field
            name="productTypeManualValues"
            component={RenderAutocompleteV2}
            label={i18n.translate(
              'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_ManualValues_Label'
            )}
            type={'product_types'}
            placeholder={i18n.translate(
              'AdminHTML.FilterTree.Item.optionModal_GeneralTab_ProductType_Placeholder'
            )}
          />
        ) : (
          <Field
            name="productTypeExcludedValues"
            component={RenderAutocompleteV2}
            label={i18n.translate(
              'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_ExcludedValues_Label'
            )}
            type={'product_types'}
            placeholder={i18n.translate(
              'AdminHTML.FilterTree.Item.optionModal_GeneralTab_ProductType_Placeholder'
            )}
            tooltip={i18n.translate(
              'AdminHTML.FilterTree.Item.optionModal_GeneralTab_ProductType_Field5_Tooltip'
            )}
          />
        )}
      </FormLayout>
    );
  }
}

const mapStateToProps = (state, props) => {
  const formFilterOptionValues = getFormValues('OptionModalForm')(state);

  return {
    optionType: _.get(formFilterOptionValues, 'optionType', ''),
    productTypeOptionValues: _.get(formFilterOptionValues, 'productTypeOptionValues', ''),
    appLanguage: _.get(state.oauth.tenantApp, 'appLanguage', APP_LANGUAGE_ENGLISH_VALUE)
  };
};

export default connect(mapStateToProps)(withI18n()(ProductType));
